import { Enable2Fa } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {},

  info: {
    dialog: {
      get title() {
        return t('ENABLE 2FA');
      },
      class: 'h-[680px]',
    },
  },
};

export default Enable2Fa;
